import React from 'react'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import LeftIndent from 'utils/LeftIndent'
import SubsByClient from 'alert_subscriptions/SubsByClient'
import SubsByUser from 'alert_subscriptions/SubsByUser'

class AlertSubscriptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabLocation: ""
    }
  }
  componentDidMount() {
    let hashLoc = location.hash.replace("#", "");
    if (hashLoc != "") {
      this.setState({ tabLocation: hashLoc })
    }
    else {
      location.hash = "#byClient"
      this.setState({ tabLocation: "byClient" })
    }
  }

  addUser(email, sectionName, sectionId) {
    let returnedData = "";
    if (email && email != "" && sectionId && sectionId != "") {
      $.ajax({
        type: "POST",
        url: "/datapulse/alerts/subscribe-user/",
        async: false,
        data: {
          email: email,
          section_name: sectionName,
          section_id: sectionId
        },
        success: (data) => {
          returnedData = data;
        }
      })
    }
    return returnedData;
  }

  removeUser(email, sectionName, sectionId) {
    let removalSuccessful = false;
    if (email && email != "" && sectionId && sectionId != "") {
      $.ajax({
        type: "POST",
        url: "/datapulse/alerts/unsubscribe-user/",
        async: false,
        data: {
          email: email,
          section_name: sectionName,
          section_id: sectionId
        },
        success: () => {
          removalSuccessful = true;
        }
      })
    }
    return removalSuccessful;
  }

  searchClients(filter, clients) {
    filter = filter.toLowerCase();
    Object.values(clients).forEach((clientRow) => {
      let clientName = clientRow.getAttribute("data-client-name").toLowerCase();
      if (!clientName.includes(filter)) {
        clientRow.style.display = "none";
      } else {
        clientRow.style.display = "table-row";
      }
    })
  }

  selectTab(key) {
    location.hash = "#" + key;
    this.setState({ tabLocation: key });
  }

  render() {
    return (
      <>
        <h1>Alert Subscriptions</h1>
        <Tab.Container className="" id="admin-tabs" defaultActiveKey="byClient" activeKey={this.state.tabLocation} onSelect={(k) => this.selectTab(k)}>
          <Nav variant="pills" className="nav-fill tabs-navigation row no-gutters row-cols-sm-1 row-cols-md-2">
            <Nav.Item className="col">
              <Nav.Link eventKey="byClient">Subscriptions By Client</Nav.Link>
            </Nav.Item>
            <Nav.Item className="col">
              <Nav.Link eventKey="byUser">Subscriptions By User</Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="byClient">
              <LeftIndent>
                <SubsByClient clients={this.props.clients} users={this.props.users} addUser={this.addUser} removeUser={this.removeUser} searchClients={this.searchClients} />
              </LeftIndent>
            </Tab.Pane>
            <Tab.Pane eventKey="byUser">
              <LeftIndent>
                <SubsByUser clients={this.props.clients} users={this.props.users} addUser={this.addUser} removeUser={this.removeUser} searchClients={this.searchClients} defaultUser={this.props.default_user} />
              </LeftIndent>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>

      </>
    );
  }
}

export default AlertSubscriptions;
